import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleMainUserModal } from 'store/entities/users';

import Button from 'components/UIComponents/Button/index';

export default () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userDetails } = useSelector(state => state.auth);

  return (
    <tr>
      <td colSpan={5}>
        <div className="space-between">
          <div>
            <strong>
              {userDetails?.firstName} {userDetails?.lastName}
            </strong>{' '}
            <br />
            {t('datagate.external.global.mainUser')}
          </div>

          <Button
            id="users-add-btn"
            aria-label="Users add button"
            color="primary"
            outlined
            onClick={() => dispatch(toggleMainUserModal())}
          >
            {t('datagate.external.users.table.button.changeMainUser')}
          </Button>
        </div>
      </td>
    </tr>
  );
};
